const levels = {
        ACCOUNT: "ACCOUNT",
        MODULE: "MODULE"
      } 
      Object.freeze(levels);
      
      export { levels };